import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-sidebar',
  templateUrl: './no-sidebar.component.html',
  styleUrls: ['./no-sidebar.component.scss']
})
export class NoSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
